import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../Config/Config";

export const fetchSubCategorynData = createAsyncThunk(
  "api/subcategory",
  async () => {
    const response = await fetch(
      `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-sub-category-list`
    );
    const data = await response.json();
    return data;
  }
);

const categorySlice = createSlice({
  name: "subcategory",
  initialState: {
    subcategorydata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubCategorynData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubCategorynData.fulfilled, (state, action) => {
        state.loading = false;
        state.subcategorydata = action.payload;
      })
      .addCase(fetchSubCategorynData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default categorySlice.reducer;
